"use strict";

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    _defineProperty(this, "_callbacks", {});
  }

  _createClass(Emitter, [{
    key: "addEventListener",
    value: function addEventListener(event, fn) {
      (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
      return this;
    }
  }, {
    key: "once",
    value: function once(event, fn) {
      var self = this;

      function on(arg) {
        self.removeEventListener(event, on);
        fn(arg);
      }

      on.fn = fn;
      this.addEventListener(event, on);
      return this;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(event, fn) {
      // all
      if (0 == arguments.length) {
        this._callbacks = {};
        return this;
      } // specific event


      var callbacks = this._callbacks['$' + event];
      if (!callbacks) return this; // remove all handlers

      if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
      } // remove specific handler


      var cb;

      for (var i = 0; i < callbacks.length; i++) {
        cb = callbacks[i];

        if (cb === fn || fn === cb['fn']) {
          callbacks.splice(i, 1);
          break;
        }
      } // Remove event specific arrays for event types that no
      // one is subscribed for to avoid memory leak.


      if (callbacks.length === 0) {
        delete this._callbacks['$' + event];
      }

      return this;
    }
  }, {
    key: "emit",
    value: function emit(event, arg) {
      this._callbacks = this._callbacks || {};
      var callbacks = this._callbacks['$' + event];

      if (callbacks) {
        var callbacksCopy = callbacks.slice(0);

        for (var i = 0, len = callbacksCopy.length; i < len; ++i) {
          callbacksCopy[i](arg);
        }
      }

      return this;
    }
  }, {
    key: "listeners",
    value: function listeners(event) {
      return this._callbacks['$' + event] || [];
    }
  }, {
    key: "hasListeners",
    value: function hasListeners(event) {
      return !!this.listeners(event).length;
    }
  }]);

  return Emitter;
}();

exports["default"] = Emitter;